import Empty from "@/components/Empty";
import SearchInput from "@/components/SearchInput";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import {
  BookA,
  FileText,
  Folder,
  Menu,
  Network,
  Settings,
  Users,
} from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAVIGATION_GROUP, useAppNavigation } from "../hooks/useAppNavigation";
import { MobileFooterButton } from "./MobileFooterButton";
import { MobileNavigationItemWithSubmenu } from "./MobileNavigationItemWithSubmenu";
import { MobileNavigationItems } from "./MobileNavigationItems";

export const MobileNavigationSheet = () => {
  const [open, setOpen] = useState(false);
  const navigation = useAppNavigation();
  const { t } = useTranslation();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <MobileFooterButton icon={Menu} title="" />
      </SheetTrigger>
      <SheetContent side="bottom" className="h-[80vh] rounded-t-xl">
        <section className="px-6 py-4 mb-4">
          <SearchInput
            placeholder={t("common.search")}
            onChange={navigation.onSearchChange}
            value={navigation.searchQuery}
            autoFocus
          />
        </section>
        <section className="flex flex-col gap-4 px-6 overflow-scroll h-[64vh]">
          <Empty
            when={navigation.searchResults.hasEmptySearchResults()}
            iconClassName="w-8 h-8"
            className="text-sm gap-2"
          >
            {t("navigation.noItems")}
          </Empty>
          {navigation.searchResults.hasGroupItems(NAVIGATION_GROUP.MAIN) && (
            <MobileNavigationItems
              items={
                navigation.searchResults.getGroupItems(NAVIGATION_GROUP.MAIN) ||
                []
              }
              className="gap-5 my-3"
            />
          )}
          {navigation.searchResults.hasGroupItems(NAVIGATION_GROUP.USERS) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.users")}
              icon={Users}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.USERS,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.PROJECTS,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.projectManagement")}
              icon={Folder}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.PROJECTS,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.PAYROLLS,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.payrolls")}
              icon={Folder}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.PAYROLLS,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.AGREEMENT_MANAGEMENT,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.agreementManagement")}
              icon={FileText}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.AGREEMENT_MANAGEMENT,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.DEPARTMENT_BASED_PROJECTS,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.departmentBasedProjectManagement")}
              icon={Folder}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.DEPARTMENT_BASED_PROJECTS,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.STRUCTURE_ASSIGNMENTS,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.structureAssignments")}
              icon={Network}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.STRUCTURE_ASSIGNMENTS,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.ADMINISTRATION,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.administration")}
              icon={Settings}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.ADMINISTRATION,
                ) || []
              }
            />
          )}
          {navigation.searchResults.hasGroupItems(
            NAVIGATION_GROUP.DICTIONARIES,
          ) && (
            <MobileNavigationItemWithSubmenu
              title={t("navigation.dictionaries")}
              icon={BookA}
              items={
                navigation.searchResults.getGroupItems(
                  NAVIGATION_GROUP.DICTIONARIES,
                ) || []
              }
            />
          )}
        </section>
      </SheetContent>
    </Sheet>
  );
};
